<svg xmlns="http://www.w3.org/2000/svg" width="64.001" height="64" viewBox="0 0 64 64">
	<path
		fill="currentColor"
		d="M23.001,54.5c-0.384,0-0.768-0.146-1.061-0.439c-0.586-0.586-0.586-1.535,0-2.121L41.88,32L21.94,12.061 c-0.586-0.586-0.586-1.535,0-2.121c0.586-0.586,1.535-0.586,2.121,0l21,21c0.586,0.586,0.586,1.535,0,2.121l-21,21 C23.769,54.354,23.385,54.5,23.001,54.5z"
	/>
</svg>
